import React from 'react';
import './OverviewCardIcons.css';

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function CardIcon({ className = 'overview-card-icon', children }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className={className}>
      {children}
    </svg>
  );
}

/** Header icon — upcoming appointments: a stack of days ahead */
export function UpcomingAppointmentsIcon() {
  return (
    <CardIcon>
      <rect x="7" y="8.2" width="13" height="12" rx="2.4" fill="currentColor" opacity="0.28" />
      <rect x="4.5" y="6" width="13" height="12" rx="2.4" fill="currentColor" opacity="0.5" />
      <rect x="2" y="3.8" width="13" height="12.2" rx="2.4" fill="currentColor" opacity="0.18" />
      <path fill="currentColor" d="M2 3.8h13a2.4 2.4 0 0 1 2.4 2.4V8.2H2V3.8Z" />
      <path d="M5.4 2.6v2.4M10.2 2.6v2.4" {...stroke} strokeWidth="1.7" />
    </CardIcon>
  );
}

/** Header icon — today's schedule: day page with a sun */
export function TodayScheduleIcon() {
  return (
    <CardIcon>
      <rect x="3" y="8" width="13.5" height="12.5" rx="2.6" fill="currentColor" opacity="0.2" />
      <path fill="currentColor" d="M3 8h13.5a2.6 2.6 0 0 1 2.6 2.6V12.2H3V8Z" />
      <path d="M6.6 6.4V9M10.4 6.4V9" {...stroke} strokeWidth="1.7" />
      <circle cx="17.4" cy="6.3" r="2.15" fill="currentColor" />
      <path
        d="M17.4 2.5v1.15M17.4 9v1.15M13.7 6.3h1.15M20 6.3h1.15M14.8 3.7l.8.8M19.2 8.1l.8.8M14.8 8.9l.8-.8M19.2 4.5l.8-.8"
        {...stroke}
        strokeWidth="1.35"
      />
    </CardIcon>
  );
}

/** Header icon — pending confirmation: hourglass */
export function PendingConfirmationIcon() {
  return (
    <CardIcon>
      <path
        fill="currentColor"
        opacity="0.2"
        d="M7.2 4.2h9.6v2c0 2-1.5 3.3-3 4.4L12 12.2l1.8 1.6c1.5 1.1 3 2.4 3 4.4v2H7.2v-2c0-2 1.5-3.3 3-4.4L12 12.2l-1.8-1.6c-1.5-1.1-3-2.4-3-4.4v-2Z"
      />
      <path fill="currentColor" d="M6.2 3h11.6v1.7H6.2V3Zm0 16.3h11.6V21H6.2v-1.7Z" />
      <path fill="currentColor" d="M9.1 6.5h5.8c-.5 1.5-1.5 2.5-2.9 3.3-1.4-.8-2.4-1.8-2.9-3.3Z" />
      <path fill="currentColor" opacity="0.85" d="M9.4 17.5h5.2c-.4-1.3-1.3-2.2-2.6-2.9-1.3.7-2.2 1.6-2.6 2.9Z" />
    </CardIcon>
  );
}

/** Header icon — upcoming meetings: two people */
export function UpcomingMeetingsIcon() {
  return (
    <CardIcon>
      <circle cx="9" cy="8.2" r="3" fill="currentColor" />
      <circle cx="16.1" cy="9.3" r="2.35" fill="currentColor" opacity="0.45" />
      <path fill="currentColor" d="M3.8 19.2c.5-3 2.8-4.7 5.2-4.7s4.7 1.7 5.2 4.7H3.8Z" />
      <path fill="currentColor" opacity="0.45" d="M13.2 15.1c1.5.3 3.1 1.4 3.7 4.1h-2.2c-.3-1.5-1.1-2.6-2.2-3.3.2-.3.4-.6.7-.8Z" />
    </CardIcon>
  );
}

/** Header icon — recent updates: filled bell with a live dot */
export function RecentUpdatesIcon() {
  return (
    <CardIcon>
      <path
        fill="currentColor"
        opacity="0.22"
        d="M12 3.6a5.4 5.4 0 0 0-5.4 5.4c0 4.6-1.7 6.2-1.7 6.2h14.2s-1.7-1.6-1.7-6.2A5.4 5.4 0 0 0 12 3.6Z"
      />
      <path
        fill="currentColor"
        d="M12 3.2a.9.9 0 0 1 .9.9 4.6 4.6 0 0 1 4.5 4.6c0 3.5 1.1 5 1.6 5.5H5c.5-.5 1.6-2 1.6-5.5A4.6 4.6 0 0 1 11.1 4.1.9.9 0 0 1 12 3.2Z"
      />
      <path fill="currentColor" d="M10.2 19.2a1.8 1.8 0 0 0 3.6 0h-3.6Z" />
      <circle cx="17.3" cy="5.4" r="2.35" fill="currentColor" />
    </CardIcon>
  );
}

/** Inline row icon — appointment time */
export function AppointmentTimeIcon() {
  return (
    <CardIcon className="overview-card-icon overview-card-icon--xs">
      <circle cx="12" cy="12" r="8" fill="currentColor" opacity="0.2" />
      <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path d="M12 8.2V12l2.5 1.6" {...stroke} strokeWidth="1.7" />
    </CardIcon>
  );
}

/** View-all / navigate arrow */
export function CardArrowRightIcon() {
  return (
    <CardIcon className="overview-card-icon overview-card-icon--action">
      <path d="M5 12h14" {...stroke} />
      <path d="m12 5 7 7-7 7" {...stroke} />
    </CardIcon>
  );
}

/** Mark update as read */
export function MarkReadIcon() {
  return (
    <CardIcon className="overview-card-icon overview-card-icon--md">
      <circle cx="12" cy="12" r="10" {...stroke} />
      <path d="m9 12 2 2 4-4" {...stroke} />
    </CardIcon>
  );
}

/** Info hint beside cancelled updates */
export function UpdateInfoIcon() {
  return (
    <CardIcon className="overview-card-icon overview-card-icon--xs">
      <circle cx="12" cy="12" r="10" {...stroke} />
      <path d="M12 16v-4" {...stroke} />
      <path d="M12 8h.01" {...stroke} />
    </CardIcon>
  );
}

/** Modal close — shared with update details dialog */
export function CardCloseIcon() {
  return (
    <CardIcon className="overview-card-icon overview-card-icon--md">
      <path d="M18 6 6 18" {...stroke} />
      <path d="m6 6 12 12" {...stroke} />
    </CardIcon>
  );
}
